import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Api } from '../api'
import type { Feature } from '../feature'

/**
 * Handles `load.request` actions: forwards the request to the API and
 * dispatches success/error/cancellation actions.
 */
export const executeLoad = store.effects.create(
  (feature: Feature, api: Api, meFeature: me.Feature) =>
    feature.actions.load.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.mergeMap(([action, context]) => {
        const request = action.data
        if (!context) {
          return rxjs.of(
            feature.actions.load.error.from(action).create({
              error: new Error('Cannot determine current context'),
              request,
            }),
          )
        }
        return api.load(context, request).pipe(
          rxjs.map(response =>
            feature.actions.load.success
              .from(action)
              .create({ request, response }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.load.error
                .from(action)
                .create({ error, request }),
            ),
          ),
        )
      }),
    ),
)
